import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as HelixLogomark } from '@assets/helix-logomark.svg';
import { ReactComponent as HelixBuilderLogo } from '@assets/helix-builder-logo.svg';

export const StyledHelixLogomark = styled(HelixLogomark, {
  marginRight: '$2',
});

export const StyledLogoContainer = styled(Box, {
  display: 'flex',
  justifyContent: 'center',
  margin: '$6 auto',
  width: '85%',
});

export const StyledHelixBuilderLogo = styled(HelixBuilderLogo);

export const StyledToSFooter = styled(Box, {
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
});
